module.exports = __webpack_public_path__ + "img/mint-poster.fd62eb92.jpg";